import { createStore } from 'vuex'

export const dataUser = createStore({
  state: () => {
    return {
      user: {
        name: undefined,
        function: undefined,
        role: undefined,
        email: undefined,
        phone: undefined,
        image_profile: undefined,
        company_id: localStorage.getItem('__company'),
      },
      password: {
        old: undefined,
        newPass: undefined,
        confirm: undefined
      },
      imgPath: undefined
    }
  },
  mutations: {
    reset (state) {
      state.user.name = undefined
      state.user.function = undefined
      state.user.role = undefined
      state.user.email = undefined
      state.user.phone = undefined
      state.password.old = undefined
      state.password.newPass = undefined
      state.password.confirm = undefined
      state.user.image_profile = undefined
      state.imgPath = undefined
    }
  }
})
